import EvolutionFilter from './EvolutionFilter'

export default EvolutionFilter



// WEBPACK FOOTER //
// ./src/modules/Filters/EvolutionFilter/index.js